// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__21eEQ","inputWrap":"CustomTip_inputWrap__iuYRg"};